import { z } from "zod";

export const SystemPermissions = {
    NONE: "NONE",
    LOGGED_ANY: "LOGGED_ANY",
    ADMIN: "ADMIN",
    HOST: "HOST",
    MANAGER: "MANAGER",
} as const;

export type SystemPermissionType =
    (typeof SystemPermissions)[keyof typeof SystemPermissions];
export const PERMISSIONS_LIST = Object.values(SystemPermissions);

// these are duplicates of types.d.ts, prismajson wasn't working here due to
// weird module resolution issues

export enum PermissionEnum {
    // CREATE_EVENTS = "create-events",
    // EDIT_EVENTS = "edit-events",
    // DELETE_EVENTS = "delete-events",
    //
    // CREATE_ROLES = "create-roles",
    // EDIT_ROLES = "edit-roles",
    // DELETE_ROLES = "delete-roles",

    RECEIVE_REGION_NOTIFICATIONS = "receive-region-notifications",
    MANAGE_REIMBURSEMENTS = "manage-reimbursements",
    PIN_EVENTS = "pin-events",
    VIEW_MEMBERSHIP_DATA = "view-membership-data", //see members of chapter, see number of subscribers or one time guests/dashboard
    SEND_EMAILS_TO_MEMBERS = "send-emails-to-members",
    SEND_SMS_TO_MEMBERS = "send-sms-to-members",

    CREATE_EVENTS = "create-events",
    CHECKIN_ATTENDEES = "checkin-attendees",
}

// make a zod schema for PermissionsType
export const PermissionSchema = z.object({
    // [PermissionEnum.CREATE_EVENTS]: z.boolean(),
    // [PermissionEnum.EDIT_EVENTS]: z.boolean(),
    // [PermissionEnum.DELETE_EVENTS]: z.boolean(),
    //
    // [PermissionEnum.CREATE_ROLES]: z.boolean(),
    // [PermissionEnum.EDIT_ROLES]: z.boolean(),
    // [PermissionEnum.DELETE_ROLES]: z.boolean(),

    [PermissionEnum.RECEIVE_REGION_NOTIFICATIONS]: z.boolean(),
    [PermissionEnum.MANAGE_REIMBURSEMENTS]: z.boolean(),
    [PermissionEnum.PIN_EVENTS]: z.boolean(),
    [PermissionEnum.VIEW_MEMBERSHIP_DATA]: z.boolean(),
    [PermissionEnum.SEND_EMAILS_TO_MEMBERS]: z.boolean(),
    [PermissionEnum.SEND_SMS_TO_MEMBERS]: z.boolean(),

    [PermissionEnum.CREATE_EVENTS]: z.boolean(),
    [PermissionEnum.CHECKIN_ATTENDEES]: z.boolean(),
});

export type PermissionsType = z.infer<typeof PermissionSchema>;

export const DEFAULT_PERMISSIONS: PermissionsType = {
    // [PermissionEnum.CREATE_EVENTS]: false,
    // [PermissionEnum.EDIT_EVENTS]: false,
    // [PermissionEnum.DELETE_EVENTS]: false,
    //
    // [PermissionEnum.CREATE_ROLES]: false,
    // [PermissionEnum.EDIT_ROLES]: false,
    // [PermissionEnum.DELETE_ROLES]: false,

    [PermissionEnum.RECEIVE_REGION_NOTIFICATIONS]: false,
    [PermissionEnum.MANAGE_REIMBURSEMENTS]: false,
    [PermissionEnum.PIN_EVENTS]: false,
    [PermissionEnum.VIEW_MEMBERSHIP_DATA]: false,
    [PermissionEnum.SEND_EMAILS_TO_MEMBERS]: false,
    [PermissionEnum.SEND_SMS_TO_MEMBERS]: false,

    [PermissionEnum.CREATE_EVENTS]: false,
    [PermissionEnum.CHECKIN_ATTENDEES]: false,
};

export const DEFAULT_CHAPTER_LEAD_PERMISSIONS: PermissionsType = {
    // [PermissionEnum.CREATE_EVENTS]: false,
    // [PermissionEnum.EDIT_EVENTS]: false,
    // [PermissionEnum.DELETE_EVENTS]: false,
    //
    // [PermissionEnum.CREATE_ROLES]: false,
    // [PermissionEnum.EDIT_ROLES]: false,
    // [PermissionEnum.DELETE_ROLES]: false,

    [PermissionEnum.RECEIVE_REGION_NOTIFICATIONS]: false,
    [PermissionEnum.MANAGE_REIMBURSEMENTS]: false,
    [PermissionEnum.PIN_EVENTS]: false,
    [PermissionEnum.VIEW_MEMBERSHIP_DATA]: false,
    [PermissionEnum.SEND_EMAILS_TO_MEMBERS]: true,
    [PermissionEnum.SEND_SMS_TO_MEMBERS]: true,

    [PermissionEnum.CREATE_EVENTS]: true,
    [PermissionEnum.CHECKIN_ATTENDEES]: true,
};

// we fallback to those permission values if they are not
// defined/consumed by any role in the community
export const APP_FALLBACK_PERMISSIONS: PermissionsType = {
    // [PermissionEnum.CREATE_EVENTS]: false,
    // [PermissionEnum.EDIT_EVENTS]: false,
    // [PermissionEnum.DELETE_EVENTS]: false,
    //
    // [PermissionEnum.CREATE_ROLES]: false,
    // [PermissionEnum.EDIT_ROLES]: false,
    // [PermissionEnum.DELETE_ROLES]: false,

    [PermissionEnum.RECEIVE_REGION_NOTIFICATIONS]: false,
    [PermissionEnum.MANAGE_REIMBURSEMENTS]: true,
    [PermissionEnum.PIN_EVENTS]: true,
    [PermissionEnum.VIEW_MEMBERSHIP_DATA]: false,
    [PermissionEnum.SEND_EMAILS_TO_MEMBERS]: false,
    [PermissionEnum.SEND_SMS_TO_MEMBERS]: false,

    [PermissionEnum.CREATE_EVENTS]: false,
    [PermissionEnum.CHECKIN_ATTENDEES]: false,
};
